import React from 'react';

export function StepProgress({ steps, currentStep }) {
  return (
    <div className="provider-steps" role="list" aria-label="Signup progress">
      {steps.map((label, index) => {
        const stepNum = index + 1;
        const isDone = stepNum < currentStep;
        const isActive = stepNum === currentStep;
        const className = [
          'provider-step',
          isDone ? 'provider-step--done' : '',
          isActive ? 'provider-step--active' : '',
        ]
          .filter(Boolean)
          .join(' ');

        return (
          <div key={label} className={className} role="listitem">
            {index > 0 && <span className="provider-step-line" aria-hidden="true" />}
            <span className="provider-step-dot" aria-current={isActive ? 'step' : undefined}>
              {isDone ? '✓' : stepNum}
            </span>
            <span className="provider-step-label">{label}</span>
          </div>
        );
      })}
    </div>
  );
}

export default StepProgress;
